/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_SkillInputs */

const en_entity_skill = /** @type {(inputs: Entity_SkillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill`)
};

const de_entity_skill = /** @type {(inputs: Entity_SkillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill`)
};

/**
* | output |
* | --- |
* | "Skill" |
*
* @param {Entity_SkillInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_skill = /** @type {((inputs?: Entity_SkillInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_SkillInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_skill(inputs)
	return de_entity_skill(inputs)
});